import { useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@azelis/ui/components/table';

import { parseTableContent } from '@/lib/parse-table-content';

interface QuestionTableProps {
  content: string;
}

/** Renders a TableQuestion's table_content through the real Table components instead of a
 * raw dangerouslySetInnerHTML blob. */
export function QuestionTable({ content }: QuestionTableProps) {
  const parsed = useMemo(() => parseTableContent(content), [content]);
  if (!parsed) {return null;}

  return (
    <Table>
      {parsed.header.length > 0 && (
        <TableHeader>
          <TableRow>
            {parsed.header.map((cell, index) => (
              <TableHead
                key={index}
                dangerouslySetInnerHTML={{ __html: cell }}
              />
            ))}
          </TableRow>
        </TableHeader>
      )}
      <TableBody>
        {parsed.rows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell
                key={cellIndex}
                dangerouslySetInnerHTML={{ __html: cell }}
              />
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
